import { useTranslation } from "react-i18next";

import { EAiAssistantChannel } from "../../aiAgents.types";

import styles from "./ChannelsTab.module.scss";

interface Props {
  channel: EAiAssistantChannel;
}

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 2C5.6 2 2 5.6 2 10c0 1.4.4 2.7 1 3.9L2 18l4.2-1.1c1.1.6 2.4 1 3.8 1 4.4 0 8-3.6 8-8s-3.6-7.9-8-7.9zm4.2 11.1c-.2.5-1 1-1.6 1.1-.4.1-.9.1-1.5-.1-.3-.1-.8-.3-1.5-.5-2.5-1.1-4.2-3.6-4.3-3.8-.1-.2-1-1.3-1-2.5 0-1.2.6-1.8.9-2 .2-.2.5-.3.7-.3h.5c.2 0 .4-.1.6.4l.8 2c.1.2.1.3 0 .5-.1.2-.2.3-.3.4-.1.2-.3.3-.4.5-.1.1-.3.3-.1.5.2.3.7 1.2 1.6 1.9 1.1 1 2 1.3 2.3 1.5.3.1.4.1.6-.1.2-.2.7-.8.8-1.1.1-.3.3-.2.5-.1.2.1 1.3.6 1.6.7.3.1.4.2.5.3.1.2.1.7-.1 1.2z"
      fill="#22C55E"
    />
  </svg>
);

const InAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M4 3h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8l-4 3v-3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
      fill="#03BF9D"
    />
  </svg>
);

const CHANNELS: Record<
  EAiAssistantChannel,
  { name: string; iconBg: string; icon: JSX.Element }
> = {
  [EAiAssistantChannel.WhatsApp]: {
    name: "WhatsApp",
    iconBg: "#dcfce7",
    icon: <WhatsAppIcon />
  },
  [EAiAssistantChannel.InAppSupport]: {
    name: "In-App Support",
    iconBg: "#d6f7f0",
    icon: <InAppIcon />
  }
};

const ChannelsTab = ({ channel }: Props) => {
  const { t } = useTranslation();
  const info = CHANNELS[channel];

  return (
    <div className={styles.list}>
      <div className={styles.channel}>
        <div className={styles.iconBox} style={{ backgroundColor: info.iconBg }}>
          {info.icon}
        </div>
        <div className={styles.name}>{t(info.name)}</div>
        <span className={styles.status}>{t("Connected")}</span>
      </div>
    </div>
  );
};

export default ChannelsTab;
